import React from 'react';
import { IColumn, Stack, Text } from '@fluentui/react';
import { ActiveLink } from 'common/components/ActiveRowLink';
import { TravelerRowItem } from '.';
import { useStyles } from './index.styles';
import { RedBoxIndicator } from 'common/components/RedBoxIndicator';
import { StatusIcon } from 'common/components/StatusIcon';

export const _renderItemColumn = (
  item: TravelerRowItem | undefined,
  _index: number | undefined,
  column: IColumn | undefined
) => {
  const styles = useStyles();
  if (item) {
    const fieldContent = item[
      column?.fieldName as keyof TravelerRowItem
    ] as string;

    const _isUrgentApproval = !Boolean(item._urgencyLevel);
    switch (column?.key) {
      case '_urgencyLevel':
        return (
          <RedBoxIndicator
            _isUrgentApproval={_isUrgentApproval}
            itemId={item?.id}
          />
        );
      case '_sortName':
        return (
          <Stack
            className={styles.statusColumnContainer}
            verticalAlign="center"
          >
            <ActiveLink
              to={`/account-management/travelers/traveler/${item.id}`}
            >
              {fieldContent}
            </ActiveLink>
          </Stack>
        );
      case 'status':
        return (
          <Stack
            verticalAlign="center"
            horizontal
            horizontalAlign="space-between"
          >
            <StatusIcon
              approval={false}
              approvalData={item}
              iconType={item.statusType!}
            />
          </Stack>
        );
      default:
        return (
          <Stack
            verticalAlign="center"
            className={styles.statusColumnContainer}
          >
            <Text>{fieldContent && fieldContent}</Text>
          </Stack>
        );
    }
  }
};
